import React,{useEffect, useState,useRef} from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Header} from './component/Header'
import { Button } from 'react-bootstrap';
import useMedia from "use-media";

const sheet = [
  {
    q:"息子と娘が誘拐された。一人しか取り戻せない\n①娘②息子\nどちらを取り戻す？",
    a1:"①娘",
    a2:"②息子",
  },
  //向学心
  {
  q:"勉強は好き？",
  a1:"好き",
  a2:"嫌い",
},{
  q:"どっちのタイプ？",
  a1:"考えるのが好き",
  a2:"体を動かすのが好き",
},{
  q:"英語は得意？",
  a1:"最低限の読みかきならできる",
  a2:"英語は本当に分からない",
},
//継続力
{
  q:"どっちが得意？",
  a1:"毎日コツコツ積み上げる",
  a2:"短期集中でやり遂げる",
},{
  q:"数年間続けていることはある？",
  a1:"ある",
  a2:"ない",
},
{
  q:"どっちが多い？",
  a1:"決めた目標は割と達成する",
  a2:"目標を決めてもいつも挫折する",
},
//内向性
{
  q:"どちらの方が楽しい？",
  a1:"一人で好きなことをする",
  a2:"みんなでパーティ",
},{
  q:"どっちだと言われることが多い？",
  a1:"聞き上手だと言われる",
  a2:"話し上手だと言われる",
},{
  q:"どっちのタイプ？",
  a1:"他人と意見の衝突は避けたい",
  a2:"他人と議論することが好き",
},{
  q:"2回連続で、サイコロを2個振って両方ゾロ目が出る確率は？",
  a1:"1/36",
  a2:"1/6",
}]

const result = [
  "かなり高い",
  "高い",
  "普通",
  "低い",
  "かなり低い"
]

const msg =[
  "あなたはかなりプログラマーに向いてます。",
  "あなたはプログラマーに向いてます。",
  "普通です。",
  "あなたはプログラマーに向いてないかもしれないです。",
  "あなたは恐らくプログラマーに向いてないです。",
]

function App() {
  const [questionNum, setQuestionNum] = useState(0)
  const [hasStart, sethHasStart] = useState(false)
  const [answerArr, setAnswerArr] = useState([])
  const [rank, setRank] = useState(0)
  const isMobileScreen = useMedia({ maxWidth: "765px" });
  const questionNumRef = useRef(questionNum);
  questionNumRef.current = questionNum;

  const onClickAnswer = (number) => {
    setAnswerArr([...answerArr,number])
    setQuestionNum(questionNum+1)
  }
  const onClickStart = () => {
    sethHasStart(true)
    setTimeout(() => {
      if(questionNumRef.current===0){
        setQuestionNum(questionNum+1)
      }
    }, 5000)
  }
  const onClickBuck = () => {
    if(questionNum === 0){
      sethHasStart(false)
    }else{
      setQuestionNum(questionNum-1)
    }
  }
  useEffect(() => {
    const total = answerArr.reduce(function(sum, element){
      return sum + element;
    }, 0)
    if(total < 12){
      setRank(0)
    }else if(total < 14){
      setRank(1)
    }else if(total < 16){
      setRank(2)
    }else if(total < 18){
      setRank(3)
    }else if(total < 21){
      setRank(4)
    }
  },[answerArr])

  return (
    <div>
      <Header isMobileScreen={isMobileScreen} />
      {
        !hasStart ?
        <div style={{backgroundColor: "#93d2f0",color: "white",height:"100vh",textAlign:"center",paddingTop:100,fontSize:26}}>
        <p style={{textDecoration:"underline"}}>あなたのプログラマー適性は{isMobileScreen &&<br />}どのくらい？</p>

        <h1 style={{backgroundColor: "#93d2f0",color: "white",margin:0,padding:"20px 0px",fontSize: isMobileScreen ? 26:36}}>【プログラマー適性チェック】</h1>

        <p>自分がプログラマーに向いてるか分からない...。</p>
        <p>そんな悩みを解消します！</p>
        <Button style={{marginTop:30, padding:"10px 20px"}}variant="success" onClick={onClickStart}>【最短1分】今すぐ無料診断</Button>

      </div>
      :
      questionNum === 11 ?
      <div style={{backgroundColor: "#93d2f0",color: "white",margin: "100px auto",padding:isMobileScreen ? 10: 100,width: isMobileScreen ? "100%": "80%",borderRadius:20}}>
        <div style={{backgroundColor:"white",width:isMobileScreen ? 200 : 300,margin:"0 auto",color: "black",borderRadius: "10px",padding:20}}>
          あなたのプログラマー適性度は……
        </div>
        <div style={{width:"60%",margin:"50px auto",justifyContent: "space-between",display:"flex",alignItems: "center",flexDirection: isMobileScreen ? "column" :"row"}}>
        <div style={{fontSize:40,margin:"100px 0px"}}>
          {result[rank]}
        </div>
        <div>
          <img alt="合格発表" src="./goukakuhappyou.png" style={{maxWidth: "100%"}} />
        </div>
        </div>
        <p style={{backgroundColor:"white",color:"black",borderRadius:30,padding: isMobileScreen ? 30 :50}}>
          {msg[rank]}
          <a href={`//twitter.com/intent/tweet?url=https://hinoshin-blog.com/programmer-aptitude-check/&text=【プログラマー適性チェック】\n私のプログラマー的精度は"${result[rank]}"でした。\nあなたもプログラマー適性チェックをしませんか？&hashtags=エンジニアLIFE`} target="_blank" rel="nofollow noopener noreferrer">
            Twitterで自慢する
          </a>
        </p>
        <div style={{width:"100%",marginTop:50}}>
          <a style={{margin:"0 auto",display:"block",textAlign:"center"}}href="https://hinoshin-blog.com/programming-selfstudy/">
            <p>こちらも参考にどうぞ。</p>
            <img style={{width: isMobileScreen ? "80%" : "50%",margin:"0 auto"}} alt="プログラミングの独学方法" src="./selfstudy.png"/></a>
        </div>
      </div>
      :
      <div style={{textAlign:"center"}}>

        <div key={sheet[questionNum].a1}>
          <div style={{backgroundColor: "#93d2f0",color: "white",height:200,display:"flex",justifyContent:"center",alignItems: "center",flexDirection: "column",marginBottom:50}}>
          <h2 style={{textDecoration:"underline"}}>適性チェック質問{questionNum+1}</h2>
          <p style={{fontSize:isMobileScreen ? 21 :28,whiteSpace:"break-spaces"}}>{sheet[questionNum].q}</p>
          </div>
          <div style={{display:"flex",flexDirection: "column",justifyContent:"center",alignItems: "center"}}>
        <Button style={isMobileScreen ?{width:"80%", borderRadius:15, height:50, fontSize:22,marginBottom:50}: {marginBottom:50,width:400, borderRadius:15, height:50, fontSize:22}} variant="primary" onClick={() => onClickAnswer(1)}>{sheet[questionNum].a1}</Button>
        <Button style={isMobileScreen ?{width:"80%", borderRadius:15, height:50, fontSize:22}: {width:400, borderRadius:15, height:50, fontSize:22}} variant="secondary" className="mx-2" onClick={() => onClickAnswer(2)}>{sheet[questionNum].a2}</Button>
          <p style={{marginTop:20,cursor:"pointer"}}onClick={onClickBuck}>←前の質問に戻る</p>
        </div>
        </div>
      </div>
      }


    </div>
  );
}

export default App;
